import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { AnalyticsService } from '@mode/shared/util-segment';

export const DowngradedSharedUtilSegmentModule = angular
  .module('downgraded-shared-util-segment', [])
  .service('AnalyticsService', downgradeInjectable(AnalyticsService)).name;
